import { Box, SxProps, Theme, useTheme } from '@mui/material';

const customStyles: Record<string, SxProps<Theme>> = {
  container: {
    width: '72px',
    height: '72px',
    borderRadius: '50%',
    backgroundColor: (theme: Theme) => theme.palette.grey[100],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

export function FormInfoIcon() {
  const theme = useTheme();

  return (
    <Box sx={customStyles.container}>
      <svg width='36' height='36' viewBox='0 0 36 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M18 3C9.716 3 3 9.716 3 18s6.716 15 15 15 15-6.716 15-15S26.284 3 18 3z'
          fill={theme.palette.primary.main}
        />
        <path
          d='M18 28.5c-.828 0-1.5-.672-1.5-1.5v-9c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5v9c0 .828-.672 1.5-1.5 1.5zM18 13.5c-.828 0-1.5-.672-1.5-1.5s.672-1.5 1.5-1.5 1.5.672 1.5 1.5-.672 1.5-1.5 1.5z'
          fill={theme.palette.common.white}
        />
        <path
          d='M18 33l-4-5h8l-4 5z'
          fill={theme.palette.primary.main}
        />
      </svg>
    </Box>
  );
}
